import React, { useMemo } from "react";
import { Row, Col, Card, Divider, Button } from "antd";
import { TTrip, CostDetails } from "../../../types/TripTypes";
import textStyles from "../../DashBoard/BookingSummary/BookingSummary.module.scss";
import styles from "../ServiceSummary/ServiceSummaryComponent.module.scss";
import { useParams } from "react-router";
import { useTripsCtx } from "../../../context/TripDetailsContext";
interface IParams {
  ride: string;
  levelOfService: string;
}

type Props = {
  tripCreationDetails: TTrip;
  tripNo: Number;
};

function ServiceSummeryTripDetails({ tripCreationDetails, tripNo }: Props) {
  const { ride, levelOfService } = useParams<IParams>();
  const { wandaTripInfoCtx } = useTripsCtx();
  const [wandaTripInfo] = wandaTripInfoCtx;
  const tripCostTotal =
    (tripCreationDetails.legCostDetails?.levelOfServiceCost ?? 0) +
    (tripCreationDetails.legCostDetails?.transportationCost ?? 0) +
    (tripCreationDetails.legCostDetails?.vehicleTypeCost ?? 0);

  return (
    <>
      <Card className={`${styles.costCardsContainer} ${styles.marginDown16}`}>
        <Row className={styles.legCostsAlign} gutter={[0, 4]}>
          <Col span={12} className={textStyles.boldText14}>
            Trip {tripNo}
          </Col>
          <Col span={12} className={textStyles.normalText14}>
            ${tripCostTotal.toFixed(2)}
          </Col>
          <Col span={24} />
        </Row>
        <Row
          className={`${textStyles.fadedNormalText14} ${styles.overallCostAlign}`}
          gutter={[0, 4]}
          align="middle"
        >
          <Col span={12}>Transportation</Col>
          <Col span={12}>
            {" "}
            $
            {tripCreationDetails.legCostDetails?.transportationCost?.toFixed(2)}
          </Col>
          <Col span={12}>{levelOfService}</Col>
          <Col span={12}>
            $
            {tripCreationDetails.legCostDetails?.levelOfServiceCost?.toFixed(2)}
          </Col>
          {ride === CostDetails.WavRide && (
            <>
              <Col span={12}>WAV Upgrade</Col>
              <Col span={12}>
                {" "}
                $
                {tripCreationDetails.legCostDetails?.vehicleTypeCost?.toFixed(
                  2
                )}
              </Col>
            </>
          )}
          <Divider className={styles.solidFadedDivider} />
        </Row>
        {(tripCreationDetails.isPlus || tripCreationDetails?.isValid) && (
          <Row
            className={`${textStyles.fadedNormalText14} ${styles.overallCostAlign}`}
            gutter={[0, 4]}
            align="middle"
          >
            {tripCreationDetails.isPlus && (
              <>
                <Col span={12}>Wanda Plus Discount</Col>
                <Col span={12} className={textStyles.greenNormalText14}>
                  {wandaTripInfo.wandaPlusDiscount * 100}% {"\u00A0\u00A0"}-$
                  {tripCreationDetails.legCostDetails?.wandaPlusDiscountCost?.toFixed(
                    2
                  )}
                </Col>
              </>
            )}

            {tripCreationDetails?.isValid &&
              tripCreationDetails.legCostDetails?.discountAmount !== 0 && (
                <>
                  <Col span={12}>Promo Code</Col>
                  <Col span={12} className={textStyles.greenNormalText14}>
                    {tripCreationDetails?.legCostDetails?.discountType ===
                    "Percentage"
                      ? `${tripCreationDetails.legCostDetails?.discountValue}%`
                      : null}
                    {"\u00A0\u00A0"}
                    {`-$${tripCreationDetails.legCostDetails?.discountAmount?.toFixed(
                      2
                    )}`}{" "}
                  </Col>
                </>
              )}
            <Divider className={styles.solidFadedDivider} />
          </Row>
        )}
        <Row className={styles.overallCostAlign} gutter={[0, 4]}>
          <Col span={12} className={textStyles.normalText16}>
            Charge amount
          </Col>
          <Col span={12} className={textStyles.boldText16}>
            ${tripCreationDetails.legCostDetails?.totalCost?.toFixed(2)}
          </Col>
        </Row>
      </Card>
    </>
  );
}

export default ServiceSummeryTripDetails;
